"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var Banner_1 = __importDefault(require("../../components/Banner/Banner"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var terms_banner_png_1 = __importDefault(require("../../../images/terms_banner.png"));
var Routes_1 = require("../../constants/Routes");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PrivacyPolicyText_1 = __importDefault(require("../../components/PrivacyPolicy/PrivacyPolicyText"));
var TermsConditionsText_1 = __importDefault(require("../../components/TermsConditions/TermsConditionsText"));
var TermsAndConditions = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var location = react_router_dom_1.useLocation();
    var privacy_policy = react_1.useRef(null);
    var scrollTop = function () {
        window.scroll(0, 0);
    };
    var privacyPolicy = function () {
        var _a;
        (_a = privacy_policy.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    react_1.useEffect(function () {
        location.pathname === Routes_1.Routes.PrivacyPolicy.path
            ? privacyPolicy()
            : scrollTop();
    }, [location.pathname]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'support terms-conditions' },
            react_1.default.createElement(Banner_1.default, { image: terms_banner_png_1.default, textSmall: 'PRIVACY_POLICY.TEXTSMALL', textBig: 'PRIVACY_POLICY.TEXTBIG' }),
            react_1.default.createElement("div", { className: classnames_1.default('container-1024', styles_module_scss_1.default.terms_conditions) },
                react_1.default.createElement(TermsConditionsText_1.default, { header: t('TERMS_CONDITIONS.HEADER'), text: t('TERMS_CONDITIONS.TEXT') }),
                react_1.default.createElement(PrivacyPolicyText_1.default, { header: t('PRIVACY_POLICY.MAIN_HEADER'), text: t('PRIVACY_POLICY.TEXT') }))),
        react_1.default.createElement(AppFooter_1.default, { layout: 'HOME' })));
};
exports.default = TermsAndConditions;
